export default class AccordionDropdown extends HTMLElement {
  connectedCallback() {
    const mq = window.matchMedia("(min-width: 1000px)");
    const accordionHeader = this.querySelector(".accordion__header");

    if (mq.matches) {
      return;
    }

    const toggleAccordion = () => {
      const accordion = this.querySelector(".accordion__panel");
      if (accordion.getAttribute("aria-expanded") === "true") {
        accordion.setAttribute("aria-expanded", "false");
        this.querySelector(".accordion__icon").classList.remove("is-open");
        accordion.style.height = "0";
      } else {
        accordion.setAttribute("aria-expanded", "true");
        this.querySelector(".accordion__icon").classList.add("is-open");
        accordion.style.height = `${accordion.scrollHeight}px`;

        // Close other accordions
        document.querySelectorAll("accordion-dropdown").forEach((item) => {
          if (item === this) {
            return;
          }

          item
            .querySelector(".accordion__panel")
            .setAttribute("aria-expanded", "false");
          item.querySelector(".accordion__icon").classList.remove("is-open");
          item.querySelector(".accordion__panel").style.height = "0";
        });
      }
    };

    accordionHeader.addEventListener("click", () => {
      toggleAccordion();
    });
  }
}

customElements.define("accordion-dropdown", AccordionDropdown);
